import { FieldProps } from "../../types";

interface ImageEditorProps extends FieldProps<string> {}

const ImageHasBlackboardEditor: React.FC<ImageEditorProps> = () => {
  return <></>;
};

export default ImageHasBlackboardEditor;
